import "./loadPosts.js";

import Datepicker from "../../node_modules/vanillajs-datepicker/js/Datepicker.js";
import Swiper from "swiper";

$(document).ready(function () {
  $(".menu-item-has-children").each(function () {
    $(this).children(".dropdown-toggle").attr("href", "javascript:void(0)");
  });
  $(".menu-item-has-children").on("click", function (e) {
    $(this).children(".dropdown-menu").toggleClass("hidden");
  });

  $("#menuHamburger").on("click", function () {
    $("#mobile-menu").toggleClass("hidden");
  });
  if (
    $("input[name=mod]").val() == "promotions" ||
    $("input[name=mod]").val() == "single-promo"
  ) {
    // var instance = NiceSelect.bind(document.getElementById("a-select"), {
    //   searchable: true,
    //   placeholder: "select",
    //   searchtext: "Wyszukaj",
    //   selectedtext: "geselecteerd",
    //   val: 26,
    // });

    const elem = document.querySelector('input[id="searchPromo"]');
    const datepicker = new Datepicker(elem, {
      format: "yyyy/mm/dd",
    });
  }
  if (
    $("input[name=mod]").val() == "main" ||
    $("input[name=mod]").val() == "single-promo"
  ) {


    const swiper = new Swiper(".swiper", {
      loop: true,
      spaceBetween: 15,
      direction: "horizontal",
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    });

    $(".swiperNextBtn").on("click", function () {
      swiper.slideNext();
    });
    $(".swiperPrevBtn").on("click", function () {
      swiper.slidePrev();
    });
  }



  if ($("input[name=mod]").val() == "newsletter") {
    $("#footer").hide();
    $(".customCheckbox").on("click", function () {
      $(this).toggleClass("customChecboxChecked");
      var checkbox = $(this).find(".checkbox");
      console.log(checkbox);
      checkbox.prop("checked", !checkbox.prop("checked"));
      console.log(checkbox.attr("name"));
      console.log(checkbox.prop("checked"));
    });

    $(".customSmallCheckbox").on("click", function () {
      $(this).toggleClass("customChecboxSmallChecked");
      var checkbox = $(this).find(".checkbox");
      checkbox.prop("checked", !checkbox.prop("checked"));
      console.log(checkbox.attr("name"));
      console.log(checkbox.prop("checked"));
    });
  }

if ($("input[name=mod]").val() == "main") {
  const tags = $(".promoTag");
  console.log(tags);
  if (tags && tags.length > 0) {
    tags.each(function () {
      const tagId = $(this).data("tag");
      let swiper = new Swiper(".promoTag" + tagId, {
        loop: true,
        spaceBetween: 15,
        direction: "horizontal",
        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        },
      });
      $(".swiperNextBtn" + tagId).on("click", function () {
        swiper.slideNext();
      });
      $(".swiperPrevBtn" + tagId).on("click", function () {
        swiper.slidePrev();
      });
    });
  }

  // const swiper = new Swiper(".swiper", {
  //   loop: true,
  //   spaceBetween: 5,
  //   direction: "horizontal",
  //   breakpoints: {
  //     480: {
  //       slidesPerView: 2,
  //       spaceBetween: 5,
  //     },
  //     1024: {
  //       slidesPerView: 3,
  //       spaceBetween: 5,
  //     },
  //     1200: {
  //       slidesPerView: 4,
  //       spaceBetween: 5,
  //     },
  //   },
  // });
}
});
